import React from "react";
import ReactCompareImage from "react-compare-image";
import AppStoreButton from "assets/app-store/app-store.svg";
import GooglePlayButton from "assets/app-store/google-play.svg";
import ecossistemaPaciente from "assets/operadoras/Eco-paciente.svg";
import ecossistemaProntLife from "assets/operadoras/Ecossistema-prontlife.svg";
import mock1 from "assets/operadoras/Mockup-brasilsaude.png";
import mock2 from "assets/operadoras/Mockup-CNS.png";
import ecossistemaProntLifeWeb from "assets/operadoras/tela-agenda-prontlife.png";
import IlustracaoBI from "assets/operadoras/Ilustracao-inteligencia-operadores.svg";
import { SectionInfo } from "components/card/SectionCard";
import { OperadorasCarouselTecnologias } from "./components/carousel/OperadorasCarouselTecnologias";

export const OperadorasPage = () => {
  return (
    <div>
      <div className="container mt-5">
        <SectionInfo
          reverse={true}
          leftComponent={
            <img
              className="image align-self-start"
              src={ecossistemaProntLife}
              style={{ maxHeight: "400px" }}
              alt=""
            />
          }
          rightComponent={
            <div>
              <p>Operadoras de Saúde</p>
              <h1 className="main-title section-card__title section-card__title-large">
                Tudo em Único Ecossistema de Saúde
              </h1>
              <h2 className="main-subtitle">
                O ProntLife é uma plataforma única de saúde que integra dados
                entre pacientes, profissionais de saúde, clínicas e operadoras
                de saúde.
              </h2>
            </div>
          }
        />
        <SectionInfo
          leftComponent={
            <img
              className="image align-self-start"
              src={ecossistemaPaciente}
              style={{ maxHeight: "300px" }}
              alt=""
            />
          }
          rightComponent={
            <>
              <div className="py-3">
                <p className="title section-card__title">
                  Paciente no Centro do Cuidado
                </p>
                <p className="subtitle">
                  Dados clínicos, exames, agendamento online, prescrições e
                  orientações de saúde compartilhados em uma única plataforma.
                </p>
              </div>

              <div className="py-3">
                <h4 className="title section-card__title">
                  Redução de custos: emergências, internações e exames
                </h4>
                <p className="subtitle">
                  Profissionais de saúde trabalham juntos no cuidado integrado
                  ao paciente, otimizando recursos com qualidade assistencial.
                </p>
              </div>
            </>
          }
        />
      </div>
      {/* <div className="container-fluid bg-blue d-none d-md-block">
        <h1 className="section-atendimento__title section-card__title-large">
          Atendimento integrado
        </h1>
        <div className="row justify-content-center">
          <div className="col-8">
            <img
              src={integracao}
              className="img-fluid align-self-start"
              alt=""
            />
          </div>
        </div>
      </div> */}
      <div className="container">
        <SectionInfo
          reverse={true}
          leftComponent={
            <div className="py-3">
              <ReactCompareImage
                leftImage={mock1}
                leftImageCss={{ alignSelf: "flex-start" }}
                rightImage={mock2}
                rightImageCss={{ alignSelf: "flex-start" }}
              />
            </div>
          }
          rightComponent={
            <div>
              <h1 className="title section-card__title">
                Identidade visual customizada
              </h1>
              <h2 className="subtitle">
                Planos de Saúde com identidade visual própria, desde a
                carteirinha de saúde até o portal do paciente
              </h2>
              <div className="d-flex justify-content-center float-md-left py-3">
                <a
                  href="https://play.google.com/store/apps/details?id=br.com.prontlife.prestador"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="px-2"
                >
                  <img
                    src={GooglePlayButton}
                    className="rounded store-button"
                    alt="Botão com link para download do aplicativo na Google Play"
                  />
                </a>
                <a
                  href="https://apps.apple.com/br/app/prontlifem%C3%A9dico/id1489353060"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="px-2"
                >
                  <img
                    className="rounded store-button"
                    src={AppStoreButton}
                    alt="Botão com link para download do aplicativo na App Store"
                  />
                </a>
              </div>
            </div>
          }
        />
        <SectionInfo
          leftComponent={
            <img
              className="img-fluid align-self-start"
              src={ecossistemaProntLifeWeb}
              alt=""
            />
          }
          rightComponent={
            <div>
              <h1 className="title section-card__title">
                Nossa tecnologia, com a sua cara e do seu jeito
              </h1>
              <h2 className="subtitle">
                Operadoras e empresas de saúde podem customizar o Prontuário e
                App do seu jeito, desde a identidade visual até protocolos
                clínicos e Planos de Cuidado.
              </h2>
            </div>
          }
        />
        <SectionInfo
          reverse={true}
          leftComponent={
            <img
              className="img-fluid align-self-start"
              src={IlustracaoBI}
              alt=""
            />
          }
          rightComponent={
            <div>
              <h1 className="title section-card__title">
                Inteligência de Gestão Clínica (BI/Analytics)
              </h1>
              <h2 className="subtitle">
                O ProntLife oferece ao gestor um painel com dados
                administrativos e clínicos que podem ser integrados ao sistemas
                de faturamento e CRM, permitindo uma tomada de decisão precisa.
              </h2>
            </div>
          }
        />
      </div>
      <OperadorasCarouselTecnologias />
    </div>
  );
};
